import React from "react";
import EmpTable from "./components/EmpTable/EmpTable";
import Header from "./components/Header/Header";

function App() {

  return (
    <div>
    <Header />,
    <EmpTable />
    </div>
  )
}

export default App;
